module.exports = __webpack_public_path__ + "img/placeholder-horizontal-blue.da2f1778.svg";